import { useState, PropsWithChildren } from 'react';

import {
  Sidebar as PasteSideBar,
  SidebarBody,
  SidebarCollapseButton,
  SidebarFooter,
  SidebarHeader,
  SidebarHeaderIconButton,
  SidebarHeaderLabel,
  SidebarPushContentWrapper,
} from '@twilio-paste/core/sidebar';
import { useUID } from '@twilio-paste/uid-library';

import { ReactComponent as Logo } from '../../../../logo.svg';

import { SideBarItems } from './SideBarItems';

interface SideBarProps extends PropsWithChildren {
  topbarSkipLinkId: string;
  mainContentSkipLinkId: string;
}

export function SideBar({ mainContentSkipLinkId, topbarSkipLinkId, children }: SideBarProps) {
  const [collapsed, setCollapsed] = useState(false);
  const sidebarNavigationSkipLinkId = useUID();
  return (
    <>
      <PasteSideBar
        sidebarNavigationSkipLinkID={sidebarNavigationSkipLinkId}
        topbarSkipLinkID={topbarSkipLinkId}
        mainContentSkipLinkID={mainContentSkipLinkId}
        collapsed={collapsed}
        variant="compact"
      >
        <SidebarHeader>
          <SidebarHeaderIconButton as="a" href="/">
            <Logo style={{ width: '20px', height: '20px' }}></Logo>
          </SidebarHeaderIconButton>
          <SidebarHeaderLabel>OIM - Applications</SidebarHeaderLabel>
        </SidebarHeader>
        <SidebarBody>
          <SideBarItems id={sidebarNavigationSkipLinkId}></SideBarItems>
        </SidebarBody>
        <SidebarFooter>
          <SidebarCollapseButton
            i18nCollapseLabel="Close sidebar"
            i18nExpandLabel="Open sidebar"
            onClick={() => setCollapsed(!collapsed)}
          />
        </SidebarFooter>
      </PasteSideBar>
      <SidebarPushContentWrapper collapsed={collapsed} variant="compact">
        {children}
      </SidebarPushContentWrapper>
    </>
  );
}
